<template>

  <component :is="layout">
    <nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
      <div class="container-fluid">
        <a class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block" href="#">
          <i class="fas fa-coins"></i> {{ $i18n.t('global.coins') }}
        </a>

        <ul class="navbar-nav align-items-center d-none d-md-flex">
          <li class="nav-item dropdown">
            <a class="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="media align-items-center">
                <span v-if="user" class="photoURL avatar avatar-sm rounded-circle" :style="{ 'background-image': 'url('+user.photoURL+')' }">
                </span>
                <div class="media-body ml-2 d-none d-lg-block">
                  <span class="mb-0 text-sm  font-weight-bold">{{ user ? user.displayName : '' }}</span>
                </div>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
              <Menu key="Coin" />
            </div>
          </li>
        </ul>

      </div>
    </nav>

    <div class="header bg-gradient-primary pb-7 pt-5 pt-md-6"></div>

    <div class="container-fluid mt--7">

      <div class="row mt-5">
        <div class="col-lg-12 order-xl-2 mb-5 mb-xl-0">
          <div v-if="coin" class="card card-profile shadow">
            <div class="row justify-content-center" style="height:0">
              <div class="col-lg-3 order-lg-2">
                <button type="button" data-toggle="modal" data-target="#coin" id="coin-image">
                  <div class="card-profile-image">
                    <img :src="coin.image" :alt="coin.title" class="rounded-circle">
                  </div>
                </button>
                <div class="modal fade" id="coin" tabindex="-1" role="dialog" :aria-labelledby="coin.title" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <h5 class="modal-title">{{ coin.title }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div v-if="coin.images && coin.images.length > 1">
                          <carousel :per-page="1" class="full-width">
                            <slide v-for="(image, index) in coin.images" :key="'image' + index + coin.key">
                              <img :src="image.src" :alt="coin.title" class="img-responsive">
                            </slide>
                          </carousel>
                        </div>
                        <div v-else>
                          <img :src="coin.image" :alt="coin.title" class="img-responsive">
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{ $i18n.t('global.close') }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-header text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
              <div class="d-flex justify-content-between">
                <button @click="$router.replace({ name: 'coin' })" class="btn btn-sm btn-info mr-4">
                  <i class="fas fa-angle-left"></i> {{ $i18n.t('global.back') }}
                </button>

                <div class="float-right hidden-xs">
                  <button @click="$router.replace({ name: 'coin.edit', params: { key: $route.params.key } })" class="btn btn-sm btn-default">
                    <i class="fas fa-edit"></i> {{ $i18n.t('global.edit') }}
                  </button>
                  <button type="button" data-toggle="modal" data-target="#delete" class="btn btn-sm btn-danger">
                    <i class="fas fa-trash-alt"></i> {{ $i18n.t('global.delete') }}
                  </button>
                  <div class="modal fade" id="delete" tabindex="-1" role="dialog" :aria-labelledby="coin.title" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title">{{ $i18n.t('global.delete') }}</h5>
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <p>{{ $i18n.t('coins.delete') }}</p>
                        </div>
                        <div class="modal-footer">
                          <button class="btn btn-secondary" data-dismiss="modal">{{ $i18n.t('global.no') }}</button>
                          <button @click="deleteCoin()" class="btn btn-primary">{{ $i18n.t('global.yes') }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>
            <div class="card-body pt-0 pt-md-4">
              <div class="row">
                <div class="col">
                  <div class="card-profile-stats d-flex justify-content-center mt-md-5">
                    <div>
                      <span class="heading">{{ coin.quantity }}</span>
                      <span class="description">{{ $i18n.t('global.quantity') }}</span>
                    </div>
                    <div v-if="coin.year !== undefined">
                      <span class="heading">{{ coin.year }}</span>
                      <span class="description">{{ $i18n.t('global.year') }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <h3> <i>{{ coin.title }}</i> </h3>
                <p>{{ coin.book.name }}</p>
                <div class="h5 font-weight-300 mb-3" style="vertical-align:middle">
                  <span v-if="coin.country">
                    <img :src="'https://www.countryflags.io/'+coin.country.toLowerCase()+'/flat/24.png'" :alt="coin.country">
                    {{ $i18n.t('countries.' + coin.country) }},
                  </span>
                  {{ $i18n.t('continents.' + coin.continent) }}
                </div>
                <p v-if="coin.description">{{ coin.description }}</p>
              </div>
            </div>
          </div>
          <div v-else class="card card-profile shadow">
            <div class="card-body pt-10 pt-md-4">
              <div class="row text-center">
                <div class="col">
                  <img src="../../../static/img/loading.gif" alt="Loading" width="75">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

    </div>
  </component>

</template>

<script>
import Footer from '../../layouts/Footer'
import Modal from '../../layouts/Modal'
import Menu from '../../layouts/Menu'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'CoinShow',
  components: { Footer, Modal, Carousel, Slide, Menu },
  computed: {
    layout () {
      return 'Layout'
    },
    books () {
      return this.$store.getters.books
    },
    user () {
      return this.$store.getters.user
    },
    coin () {
      return this.$store.getters.coin
    }
  },
  created () {
    this.$store.dispatch('fetchUser')
    this.$store.dispatch('fetchBooks')
    this.$store.dispatch('fetchCoin', { key: this.$route.params.key })
  },
  methods: {
    goBack () {
      if (localStorage.back && localStorage.params) {
        let back = localStorage.back
        let params = JSON.parse(localStorage.params)
        if (localStorage.back !== 'null') {
          if (localStorage.params) {
            this.$router.replace({ name: back })
          } else {
            this.$router.replace({ name: back, params: params })
          }
        }
      }
    },
    deleteCoin () {
      let key = this.$route.params.key
      if (this.user) {
        this.$store.dispatch('deleteCoin', { key }).then(() => {
          window.location.href = '/coins'
        })
      }
    }
  }
}
</script>

<style scoped>
  .margin-images {
    display: flex;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  #search { height: 30px; }
  .sort-hover:hover { cursor: pointer; }
  .VueCarousel-slide {
    visibility: visible;
    flex-basis: 100%;
    width: 100%;
  }
  #coin-image {
    background-color: transparent;
    border: 0;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 0;
    outline: none;
  }
  #coin-image:hover {
    cursor: pointer;
  }
  @media screen and (max-width: 375px) {
    .hidden-xs { display: none; }
  }
</style>



// WEBPACK FOOTER //
// src/components/Coin/CoinShow.vue